import axios from 'axios';
import querystring from "querystring";
import status from "statuses";
import { get, isEmpty } from "lodash";

import { LOCAL_ENDPOINTS } from '../config';

function getBaseUrl() {
  let env = process.env.NODE_ENV || "development";
  if (process.env.API_BASE_URL) return process.env.API_BASE_URL;
  if (env === "production") {
    return "http://localhost:8080";
  } else {
    return "http://localhost:8080";
  }
}

function getDefaultHeaders() {
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  return headers;
}

function handleResponse(response) {
  let contentType = response.headers.get("content-type");
  if (/json/i.test(contentType)) {
    return response.json().then(data => {
      response.data = data;
      if (response.ok !== true) {
        if(get(response, "data.error_code")) {
          throw response.data;
        }
        let error = Error(status[response.status]);
        error.response = response;
        throw error;
      }
      return response;
    });
  } else {
    if (response.ok !== true) {
      let error = Error(status[response.status]);
      error.response = response;
      throw error;
    }
    return response;
  }
}

function getResource(endpoint, options = {}) {
  let query = get(options, "query");
  if (query) query = querystring.stringify(query);
  if (isEmpty(query) === false) endpoint += `?${query}`;
  options = Object.assign(
    {
      headers: getDefaultHeaders()
    },
    options
  );
  return fetch(endpoint, options).then(handleResponse);
}

function postResource(endpoint, options = {}) {
  let query = get(options, "query");
  if (query) query = querystring.stringify(query);
  if (isEmpty(query) === false) endpoint += `?${query}`;
  options = Object.assign(
    {
      method: "POST",
      headers: getDefaultHeaders()
    },
    options
  );
  return fetch(endpoint, options).then(handleResponse);
}

function putResource(endpoint, options = {}) {
  let query = get(options, "query");
  if (query) query = querystring.stringify(query);
  if (isEmpty(query) === false) endpoint += `?${query}`;
  options = Object.assign(
    {
      method: "PUT",
      headers: getDefaultHeaders()
    },
    options
  );
  return fetch(endpoint, options).then(handleResponse);
}

function deleteResource(endpoint, options = {}) {
  options = Object.assign(
    {
      method: "DELETE",
      headers: getDefaultHeaders()
    },
    options
  );
  return fetch(endpoint, options).then(handleResponse);
}

function fetchTokens(code) {

  const { CLIENT_ID } = this.state;

  if (!code) {
    //Wait for cod
    return {};
  } else {
    return axios({
      method: "POST",
      url: LOCAL_ENDPOINTS.getAuthorizationTokens,
      headers: {
        'Authorization': CLIENT_ID,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: {
        grant_type: "authorization_code",
        code,
        redirect_uri: LOCAL_ENDPOINTS.HOST_VERIFIED
      }
    }).then(result => {
      const { data } = result;
      const { Id_token, access_token, expires_in, refresh_token, token_type } = data;
      return { Id_token, access_token, expires_in, refresh_token, token_type };
    })
    .catch(err => {
      alert("Network error. Contact your administrator");
      this.setState({ network_state: false })
      return {}
    })
  }
}

function storeXeroResponseCode(options) {
  let endpoint = `${LOCAL_ENDPOINTS.storeXeroResponseCode}`;
  return postResource(endpoint, options)
}

export {
  fetchTokens,
  storeXeroResponseCode
}